import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { withI18nContext } from '@mc/i18n'
import i18nInstance from '../../../../i18n/i18nInstance'

class PrevArrow extends React.PureComponent {
  clickHandler(options, e) {
    if (e) e.preventDefault()
    this.props.clickHandler(options, e)
  }

  render() {
    const prevClasses = {
      'slick-arrow': true,
      'slick-prev': true,
    }
    let prevHandler = this.clickHandler.bind(this, { message: 'previous' })
    let prevArrowProps = {}

    if (
      !this.props.infinite &&
      (this.props.currentSlide === 0 ||
        this.props.slideCount <= this.props.slidesToShow)
    ) {
      prevClasses['slick-disabled'] = true
      prevArrowProps.disabled = true
      prevHandler = null
    }

    prevArrowProps = {
      ...prevArrowProps,
      key: '0',
      className: classnames(prevClasses),
      style: { display: 'block' },
      onClick: prevHandler,
    }

    const prevArrow = this.props.prevArrow ? (
      React.cloneElement(this.props.prevArrow, {
        ...prevArrowProps,
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount,
      })
    ) : (
      <button key='0' type='button' {...prevArrowProps}>
        {this.props.t('carousel.previousButtonAlt')}
      </button>
    )

    return prevArrow
  }
}

PrevArrow.propTypes = {
  clickHandler: PropTypes.func.isRequired,
  currentSlide: PropTypes.number.isRequired,
  slideCount: PropTypes.number.isRequired,
  prevArrow: PropTypes.node,
  slidesToShow: PropTypes.number.isRequired,
  infinite: PropTypes.bool.isRequired,
  t: PropTypes.func,
}

export default withI18nContext(i18nInstance)(PrevArrow)
